export const OVERLAY_DURATION_S = 0.55;
export const TRANSITION_EASING: [number, number, number, number] = [0.22, 1, 0.36, 1];

export const iconButtonBaseSx = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	border: 'none',
	background: 'transparent',
	padding: 0,
	cursor: 'pointer',
	flexShrink: 0
} as const;

export const srOnlySx = {
	position: 'absolute',
	width: 1,
	height: 1,
	p: 0,
	m: -1,
	overflow: 'hidden',
	clip: 'rect(0, 0, 0, 0)',
	whiteSpace: 'nowrap',
	border: 0
} as const;
